<template>
  <div class="container">
    <div class="card">
      <div class="card-body maadi-dark-card">
        <div class="m-1 text-center" style="font-size: 1.6em; font-weight: 500">
          Engagment Dashboard
        </div>
        <title-bar title="THIS FEATURE IS NOT UP TO DATE OR CURRENTLY BEING DEVELOPED"/>
        <div class="pb-3 text-center" style="font-size: 1em; font-weight: 300">
          <br>Here is the latest report. Contact Reece or Dave with further inquiries. Please do not share.
        </div>
        <div class="p-1">
        <!-- <b-embed type="iframe" title="12 Months Rolling - 1st Take" src="https://app.powerbi.com/view?r=eyJrIjoiZmUxZWIyYWYtNDQyMS00N2NlLWIzNmQtYjE2Y2FiMWQyMWVmIiwidCI6IjNmNGViZjY3LWY3OTYtNGFhMS1hMTc1LWNkMjFmMTk1OTExZiIsImMiOjN9" allowFullScreen></b-embed> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '../../homePage/TitleBar.vue';

export default {
  name: 'Embedded Reports',
  components: { TitleBar }
}
</script>


// WEBPACK FOOTER //
// src/components/organizations/reports/EmbeddedReports.vue